/** True when the SPA runs as a top-level page (not inside Figma/Framer iframe). */
export function isStandaloneBrowser(): boolean {
  if (typeof window === "undefined") return true;
  return window === window.parent;
}

/** True when embedded in a design-tool plugin shell (iframe with postMessage host). */
export function isPluginEmbed(): boolean {
  return !isStandaloneBrowser();
}
